import { observer } from "mobx-react-lite"
import { PlacesType, Tooltip as ReactTooltip } from "react-tooltip"
import styles from "./styles.module.scss"
import classNames from "classnames"

type TooltipProps = {
  id: string
  isOpen: boolean
  place?: PlacesType
  variant?: "light" | "dark"
  testID?: string
}

export const Tooltip = observer(
  ({ id, isOpen, place = "bottom", variant = "light", testID }: TooltipProps) => {
    return (
      <ReactTooltip
        id={id}
        className={classNames(
          styles.tooltip,
          variant === "light" ? styles.tooltipLight : styles.tooltipDark,
        )}
        openOnClick
        delayHide={300}
        isOpen={isOpen}
        data-testid={testID}
        place={place}
      />
    )
  },
)
